import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React from 'react';

interface CreateUserDialogProps {
  open: boolean;
  onClose: () => void;
  onCreate: (userData: { email: string; password: string; firstName?: string; lastName?: string; super_admin: boolean; tenant_admin: boolean; owner?: string }) => void;
  isSuperAdmin?: boolean;
  currentUserOwner?: string;
}

function CreateUserDialog({ open, onClose, onCreate, isSuperAdmin, currentUserOwner }: CreateUserDialogProps) {
  const [email, setEmail] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [firstName, setFirstName] = React.useState('');
  const [lastName, setLastName] = React.useState('');
  const [owner, setOwner] = React.useState('');
  const [role, setRole] = React.useState<'user' | 'tenant_admin' | 'super_admin'>('user');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const effectiveOwner = role === 'super_admin' ? undefined : (currentUserOwner || owner || undefined);
    if (email && password && (role === 'super_admin' || effectiveOwner)) {
      onCreate({
        email,
        password,
        firstName: firstName || undefined,
        lastName: lastName || undefined,
        owner: effectiveOwner,
        super_admin: role === 'super_admin',
        tenant_admin: role === 'tenant_admin'
      });
      resetForm();
    }
  };

  const resetForm = () => {
    setEmail('');
    setPassword('');
    setFirstName('');
    setLastName('');
    setOwner('');
    setRole('user');
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Create New User</DialogTitle>
        <DialogContent>
          {isSuperAdmin && <FormControl fullWidth size="small" sx={{ mt: 1 }}>
            <InputLabel>Role</InputLabel>
            <Select value={role} label="Role" onChange={(e) => { setRole(e.target.value as typeof role); if (e.target.value === 'super_admin') setOwner(''); }}>
              <MenuItem value="user">User</MenuItem>
              <MenuItem value="tenant_admin">Tenant Admin</MenuItem>
              <MenuItem value="super_admin">Super Admin</MenuItem>
            </Select>
          </FormControl>}
          <TextField
            required
            margin="dense"
            label="Email"
            type="email"
            fullWidth
            size="small"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            required
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            size="small"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            margin="dense"
            label="First Name"
            fullWidth
            size="small"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <TextField
            margin="dense"
            label="Last Name"
            fullWidth
            size="small"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          {isSuperAdmin && <TextField
            margin="dense"
            label="Owner"
            fullWidth
            size="small"
            required={role !== 'super_admin'}
            value={role === 'super_admin' ? '' : (currentUserOwner || owner)}
            onChange={(e) => setOwner(e.target.value)}
            disabled={role === 'super_admin' || !!currentUserOwner}
            helperText={role === 'super_admin' ? 'Not applicable for Super Admins' : 'Tenant this user belongs to'}
          />}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained">Create</Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default CreateUserDialog;
